import { ChakraProvider } from '@chakra-ui/react'
import { Router } from './setup/routes'
import { BrowserRouter } from 'react-router-dom'
import { ApolloClient, InMemoryCache, ApolloProvider, createHttpLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { ExtendedTheme } from './styles/theme'
import { getEnvironmentURL } from './commons/env'
import { getAdminToken } from './auth/auth.support'

const httpLink = createHttpLink({ uri: getEnvironmentURL.server })

const authLink = setContext((_, { headers }) => {
  const token = getAdminToken()
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  }
})

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
})

export const App = (): JSX.Element => {
  return (
    <ChakraProvider theme={ExtendedTheme}>
      <ApolloProvider client={client}>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </ApolloProvider>
    </ChakraProvider>
  )
}
